import {IPromise, IQService} from 'angular';
import {IState} from 'angular-ui-router';
import FondssuisseRS from '../core/service/FondssuisseRS.rest';
import {RouterHelper} from '../dvbModules/router/route-helper-provider';
import {TSRole} from '../models/enums/TSRole';
import TSBenutzer from '../models/TSBenutzer';
import {ApplicationPropertyRS} from './service/applicationPropertyRS.rest';
import {SerfPropertyRS} from './service/serfPropertyRS.rest';

adminRun.$inject = ['RouterHelper'];

/* @ngInject */
export function adminRun(routerHelper: RouterHelper) {
    routerHelper.configureStates(getStates());
}

function getStates(): IState[] {
    return [
        {
            name: 'admin',
            template: '<dv-admin-view flex="auto" class="overflow-scroll" application-properties="$resolve.applicationProperties" serf-properties="$resolve.serfProperties"></dv-admin-view>',
            url: '/admin',
            resolve: {
                applicationProperties: getApplicationProperties,
                serfProperties: getSerfProperties
            }
        },

        {
            name: 'konfiguration',
            template: '<dv-konfiguration-view flex="auto" class="overflow-scroll" serf-properties="$resolve.serfProperties" '
            + 'sachbearbeiter-list="$resolve.sachbearbeiterList" admin-list="$resolve.adminList"></dv-konfiguration-view>',
            url: '/konfiguration',
            resolve: {
                serfProperties: getSerfProperties,
                sachbearbeiterList: loadFSSachbearbeiter,
                adminList: loadFSAdmin
            }
        },
        {
            name: 'migration',
            template: '<dv-migration-view></dv-migration-view>',
            url: '/migration',
            resolve: {}
        },

    ];
}

// FIXME dieses $inject wird ignoriert, d.h, der Parameter der Funktion muss exact dem Namen des Services entsprechen

getApplicationProperties.$inject = ['ApplicationPropertyRS'];

/* @ngInject */
function getApplicationProperties(ApplicationPropertyRS: ApplicationPropertyRS) {
    return ApplicationPropertyRS.getAllApplicationProperties();
}

getSerfProperties.$inject = ['SerfPropertyRS'];

/* @ngInject */
function getSerfProperties(SerfPropertyRS: SerfPropertyRS) {
    return SerfPropertyRS.getAllSerfProperties();
}

loadFSSachbearbeiter.$inject = ['FondssuisseRS', '$q'];

export function loadFSSachbearbeiter(FondssuisseRS: FondssuisseRS, $q: IQService): IPromise<Array<TSBenutzer>> {
    return FondssuisseRS.getBenutzerOfFondssuisse(TSRole.FONDSSUISSE_SACHBEARBEITER);
}

loadFSAdmin.$inject = ['FondssuisseRS', '$q'];

export function loadFSAdmin(FondssuisseRS: FondssuisseRS, $q: IQService): IPromise<Array<TSBenutzer>> {
    return FondssuisseRS.getBenutzerOfFondssuisse(TSRole.FONDSSUISSE_ADMIN);
}






// WEBPACK FOOTER //
// ./src/app/admin/admin.route.ts